/* global browser */

import { create } from '../utils.mjs';
import Loader from '../loader.mjs';
import FormanConfig from '../formanConfig.mjs';
import { IML } from '../deps/iml.mjs';
import { I18n } from '../helpers/i18n.mjs';

const FormulaOAuth = {
	/*
	Called from RemoteFormula to open popup on user's click event and prevent popup to be blocked.
	*/

	activeWindow: null,

	win(url = '/oauth/wait') {
		if (browser.mobile) {
			return;
		}
		const win = FormulaOAuth.openWindow(url);

		FormulaOAuth.activeWindow = win;
		FormulaOAuth.setContent(win);
		return win;
	},

	async auth(oauthWindow, connectionId, scope, context = {}) {
		this.setLoading(I18n.l('panels.account.creating'));

		if (!scope) scope = [];

		context = { ...context, ...{ connectionId } };

		// refactor this
		const apiPath =
			context.accountOwner === 'personal-connections'
				? FormanConfig.config.fields.account.api.auth.pathPersonal
				: FormanConfig.config.fields.account.api.auth.path;

		const url = FormulaOAuth.getUrl(IML.execute(IML.parse(apiPath), context), connectionId, scope);

		console.log('[imt:oauth_auth]', url);

		const check = async () => {
			this.setLoading(I18n.l('panels.account.waiting'));

			await FormulaOAuth.waitForAuthentication({
				oauthWindow,
				connectionId,
				accountOwner: context.accountOwner,
				onReady: async () => {
					this.setLoading(I18n.l('panels.account.verifying'));
					await FormulaOAuth.test(connectionId, context.accountOwner);
				},
			});
		};

		if (browser.mobile) {
			this.setLoading(false);

			// on mobile browsers theres a problem that i cant make ajax request in inactive window so i have to ask user to click once again to open popup
			this.content = create('button.btn.btn-primary[type="button"]');
			this.content.textContent = I18n.l('panels.account.authorize');
			this.content.addEventListener('click', async () => {
				oauthWindow = FormulaOAuth.openWindow(url);

				if (!oauthWindow) throw new Error(I18n.l('common.popup'));

				this.setLoading(I18n.l('panels.account.waiting'));
				return await check();
			});
		} else {
			oauthWindow = FormulaOAuth.openWindow(url);
			return await check();
		}
	},

	async waitForAuthentication({ oauthWindow, connectionId, accountOwner, onReady }) {
		return new Promise((resolve, reject) => {
			let callbackCheckTimer = null;
			let callbackCheckTimeout = false;

			const closeCheckTimer = setInterval(async () => {
				if (oauthWindow.closed) {
					// If check timeouts pass the check and try to test the connection anyway
					if (callbackCheckTimeout || (await FormulaOAuth.isReady(connectionId, accountOwner))) {
						clearInterval(closeCheckTimer);

						try {
							onReady && (await onReady());
							resolve();
						} catch (ex) {
							reject(ex);
						}
					} else {
						if (!callbackCheckTimer) {
							callbackCheckTimer = setTimeout(() => {
								callbackCheckTimeout = true;
								console.log('[imt:oauth_auth]', 'auth check timeouted');
							}, 30000);
						}
					}
				}
			}, 1000);
		});
	},

	async isReady(connectionId, accountOwner = 'connections') {
		let response;

		try {
			response = await Loader.guardedLoad(
				FormanConfig.config.fields.account.api.check.path,
				{
					context: { connectionId, accountOwner },
					method: 'GET',
				},
				true,
			);
			// eslint-disable-next-line no-unused-vars
		} catch (ex) {
			// In case of the error pass the test to do not prevent creation of the connection
			return true;
		}

		return !response?.connection?.authorizing || false;
	},

	async test(connectionId, accountOwner = 'connections') {
		const response = await Loader.guardedLoad(
			FormanConfig.config.fields.account.api.test.path,
			{
				context: { connectionId, accountOwner },
				method: 'POST',
			},
			true,
		);

		if (!response.verified) {
			throw new Error(I18n.l('panels.account.verifyfailed'));
		}
	},

	async extend(connectionId, scope, personalConnection = false) {
		const apiPath = personalConnection
			? FormanConfig.config.fields.account.api.extend.pathPersonal
			: FormanConfig.config.fields.account.api.extend.path;

		const accountOwner = personalConnection ? 'personal-connections' : 'connections';
		const url = FormulaOAuth.getUrl(IML.execute(IML.parse(apiPath), { connectionId }), connectionId, scope);

		console.log('[imt:oauth_extendScope]', url);

		const oauthWindow = FormulaOAuth.openWindow(url);

		if (!oauthWindow) {
			throw new Error(I18n.l('common.popup'));
		}

		await FormulaOAuth.waitForAuthentication({
			oauthWindow,
			connectionId,
			accountOwner,
			onReady: async () => {
				this.setLoading(I18n.l('panels.account.verifying'));

				const response = await Loader.guardedLoad(
					FormanConfig.config.fields.account.api.scoped.path,
					{
						context: { connectionId, accountOwner },
						method: 'POST',
						body: { scope: scope },
					},
					true,
				);

				if (!response.connection?.scoped) {
					throw new Error(I18n.l('panels.account.extendfailed'));
				}
			},
		});
	},

	getUrl(url, connectionId, scope) {
		const params = [];

		if (scope?.length) {
			params.push(`scope=${scope.map(encodeURIComponent).join('&scope=')}`);
		}

		if (imt.standalone) {
			url = imt.apiurl + url;
		}

		const queryString = params.length ? `?${params.join('&')}` : '';

		return url + queryString;
	},

	setContent(oauthWindow) {
		return oauthWindow?.document?.write('<p> Authorizing...</p>');
	},

	openWindow(url) {
		return window.open(
			url,
			'authAccountWindow',
			'toolbar=no, scrollbars=yes,location=no,status=no,width=1024,height=768',
		);
	},

	close(res) {
		FormulaOAuth.activeWindow.close();
		return (FormulaOAuth.activeWindow = null);
	},
};

export default FormulaOAuth;
window.FormulaOAuth = FormulaOAuth;
